var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        {
          staticClass: "_view_container",
          style: { height: _vm.h + "px", width: _vm.w + "px" }
        },
        [
          _c("div", { staticClass: "_view_container_inner" }, [
            _c("div", {
              staticClass: "viewer-button viewer-close",
              attrs: { role: "button", "data-viewer-action": "mix" }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "_view_container_mask",
              on: { click: _vm.closeBox }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "_view_container_body" }, [
              _vm.imgs.length > 0
                ? _c(
                    "div",
                    {
                      ref: "_iview_content",
                      staticClass: "_iview_content",
                      on: { click: _vm.continerClick }
                    },
                    [
                      _c(
                        "el-carousel",
                        {
                          ref: "carousel",
                          staticStyle: { height: "100%", width: "100%" },
                          attrs: {
                            arrow: "always",
                            loop: _vm.loop,
                            "indicator-position": "none",
                            height: "100%"
                          }
                        },
                        _vm._l(_vm.imgs, function(item, index) {
                          return _c(
                            "el-carousel-item",
                            {
                              key: index,
                              staticStyle: { height: "100%", width: "100%" }
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  "max-width": "100%",
                                  "max-height": "100%",
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)"
                                },
                                attrs: { src: item }
                              })
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-611dd5ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-611dd5ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PreviewImage.vue
// module id = null
// module chunks = 